export { LitFlatpickr } from './src/LitFlatpickr.js';
